(function () {
  function getActiveFilters() {
    const params = new URLSearchParams(window.location.search);
    const sizeFilters = [];
    params.forEach((value, key) => {
      if (key.toLowerCase().includes('filter') && 
          key.toLowerCase().includes('size')) {
        sizeFilters.push(value.toLowerCase().trim());
      }
    });
    return sizeFilters;
  }

  function applyStockFilter() {
    const activeFilters = getActiveFilters();
    if (activeFilters.length === 0) return; // no size filter active, do nothing

    const cards = document.querySelectorAll('[data-available-sizes]');
    cards.forEach((card) => {
      const availableSizes = (card.dataset.availableSizes || '')
        .split(',')
        .map(s => s.trim().toLowerCase())
        .filter(Boolean);

      const hasMatch = activeFilters.every(filterSize =>
        availableSizes.includes(filterSize)
      );

      if (!hasMatch) {
        card.style.display = 'none';
      } else {
        card.style.display = '';
      }
    });
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', applyStockFilter);

  // Re-run after Dawn's AJAX filter updates the DOM
  document.addEventListener('shopify:section:load', applyStockFilter);

  // Hook into Dawn's fetch-based filter navigation
  const originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(history, arguments);
    setTimeout(applyStockFilter, 300);
  };

  window.addEventListener('popstate', () => setTimeout(applyStockFilter, 300));

  // Observer for Dawn 14's ajax filter DOM swaps
  const observer = new MutationObserver(() => {
    setTimeout(applyStockFilter, 100);
  });

  function startObserver() {
    const productGrid = document.querySelector('#product-grid, .collection');
    if (productGrid) {
      observer.observe(productGrid, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', startObserver);
})();